module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"Status":"Fund Type","Insured":"Insured","Spouse":"Spouse"},"si":{"Status":"Fund Type","Insured":"රක්ෂිතයා","Spouse":"කලත්‍රයා"},"ta":{"Status":"Fund Type","Insured":"வாழ்க்கை","Spouse":"வாழ்க்கைத்துணை"}}')
  delete Component.options._Ctor
}
